// extracted by mini-css-extract-plugin
export default {"container":"credits_container__npxCC","divisor":"credits_divisor__shM4f"};